import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';
import priceOfferNS from './constants/priceOfferNS';
import { getUserId } from '../../localStorages';

export default data => {
  let newPriceOfferNS = priceOfferNS;
  if (data && data.pricingModel === 'COMPLEX') {
    newPriceOfferNS = newPriceOfferNS.filter(item => item !== 'timeUnit');
  }
  const newData = data;
  newData.userId = getUserId() || newData.userId || null;
  const dataCreate = parseToMutationRequest(newData, newPriceOfferNS);
  const createPriceOffer = `createPriceOffer(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createPriceOffer} {
      id
    }
  }
`;
};
